<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <span class="headline font-weight-bold">Sugerencias de Cursos</span>
          </v-card-title>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="itemsCurso"
              class="transparent"
              item-key="id"
              hide-default-footer
              disable-pagination
              dense
              show-expand
              :expanded.sync="expanded"
            >
              <template v-slot:item.CUIP="{ item }">
                <div>{{ item.CUIP }}</div>
              </template>
              <template v-slot:item.nombreCompleto="{ item }">
                <div>{{ item.nombreCompleto }}</div>
              </template>
              <template v-slot:item.sugerenciaSubcategoria="{ item }">
                <div>{{ item.sugerenciaSubcategoria }}</div>
              </template>
              <template v-slot:item.sugerencia="{ item }">
                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px">
                  {{ item.sugerencia }}
                </div>
              </template>
              <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length">
                  <div class="pa-4">
                    <strong>Sugerencia completa:</strong>
                    <div>{{ item.sugerencia }}</div>
                  </div>
                </td>
              </template>
              <template v-slot:no-data>
                <div class="text-h6 justify-center" align="center">
                  No hay solicitudes de cursos a personal registradas
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      headers: [
        { text: 'CUIP', value: 'CUIP' },
        { text: 'Nombre completo', value: 'nombreCompleto' },
        { text: 'Subcategoría', value: 'sugerenciaSubcategoria' },
        { text: 'Sugerencia', value: 'sugerencia' },
      ],
      expanded: [],
    }
  },
  computed: {
    ...mapGetters('sugerenciaCursos', {
      sugerenciaCursos: 'getSugerenciaCursos',
    }),
    itemsCurso() {
      return this.sugerenciaCursos.map((sugerencia, idx) => ({
        id: sugerencia.id || idx,
        sugerencia: sugerencia.comentario || sugerencia.sugerencia || '',
        sugerenciaSubcategoria: sugerencia.Curso?.subcategoria || '',
        nombreCompleto: [
          sugerencia.Person?.nombre,
          sugerencia.Person?.segundoNombre,
          sugerencia.Person?.apaterno,
          sugerencia.Person?.amaterno,
        ]
          .filter(Boolean)
          .join(' '),
        CUIP: sugerencia.Person?.CUIP || '',
        ...sugerencia,
      }))
    },
  },
  watch: {
    expanded(val) {
      if (val.length > 1) {
        this.expanded = [val[val.length - 1]]
      }
    },
  },
}
</script>

<style>
.tooltip-ancho-custom {
  display: block;
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}
</style>
